import styled from 'styled-components'
import { shadows } from 'ThemeStyle'

export const Wrapper = styled.div`
  width: 100%;
  margin: 10px 0 10px 0;
  display: flex;
  flex-direction: column;

  border-radius: 10px;
  transition: all 0.3s ease;
  box-shadow: ${shadows.small};
  padding: 10px;
  min-height: 150px;
  box-sizing: border-box;
`

export const Row = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  justify-content: space-between;
  height: 100%;
  gap: 12px;

  @media (max-width: 700px) {
    flex-direction: column;
    align-items: stretch;
  }
`

export const CardImage = styled.div`
  position: relative;
  height: 140px;
  width: 140px;
  flex-shrink: 0;
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;
  margin-right: 20px;
  transition: all 0.3s ease;

  &:hover {
    transform: rotate(3deg) scale(1.05);
  }

  @media (max-width: 700px) {
    width: 100%;
    height: 180px;
    margin-right: 0;
  }
`

export const Description = styled.div`
  width: 60%;
  height: 100%;
  min-width: 0;

  @media (max-width: 700px) {
    width: 100%;
  }
`

export const Title = styled.div`
  display: block;
  font-size: 1.17em;
  font-weight: bold;
`

export const IngredientWrapper = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  gap: 10px;
  transition: all 0.5s ease;
`

export const PriceWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  align-items: center;
  width: 200px;
  height: 140px;
  flex-shrink: 0;

  @media (max-width: 700px) {
    width: 100%;
    height: auto;
    flex-direction: row;
    justify-content: space-between;
    padding-top: 8px;
  }
`
